import { FunctionComponent } from 'react'
import Head from 'next/head'
import { RecaptchaContextProvider } from '../../contexts/recaptcha-context'
import { useRecaptchaHook } from '@lib/hooks'
import { getSrcUrl, isReCaptchaScriptLoaded } from '../utils/recaptcha'
import { RecaptchaConfig } from '@lib/types'

export const withRecaptcha = <T extends object>(
  recaptchaConfig: RecaptchaConfig,
  Component: FunctionComponent<T>
): FunctionComponent<T> => {
  const WithRecaptcha = (props: T) => {
    const execute = useRecaptchaHook(recaptchaConfig)

    return (
      <>
        {!isReCaptchaScriptLoaded() && (
          <Head>
            <script data-key="captcha" type="text/javascript" src={getSrcUrl(recaptchaConfig)} defer async />
          </Head>
        )}
        <RecaptchaContextProvider value={execute}>
          <Component {...(props as T)} />
        </RecaptchaContextProvider>
      </>
    )
  }
  WithRecaptcha.displayName = `withRecaptcha(${Component.displayName || Component.name || 'Component'})`
  return WithRecaptcha
}
